import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=0d00c6a4&scoped=true&"
import script from "./model_list.vue?vue&type=script&lang=js&"
export * from "./model_list.vue?vue&type=script&lang=js&"
import style0 from "./model_list.vue?vue&type=style&index=0&id=0d00c6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00c6a4",
  null
  
)

export default component.exports